import { render, staticRenderFns } from "./ot-document-list.vue?vue&type=template&id=4c320392&scoped=true&"
import script from "./ot-document-list.vue?vue&type=script&lang=ts&"
export * from "./ot-document-list.vue?vue&type=script&lang=ts&"
import style0 from "./ot-document-list.vue?vue&type=style&index=0&id=4c320392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c320392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VChip,VIcon,VMenu,VTooltip})
